import { createContext } from 'react';

import {
  AddEditRegion,
  RegionSummaryItem,
} from '@totem/components/portfolio/regions/types';

interface Context {
  loading: boolean;
  sending: boolean;
  data: RegionSummaryItem[];
  totalRecords: number;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  isModalOpen: boolean;
  isEdit: boolean;
  editingRegion: AddEditRegion;
  onAction: (action: string, region?: RegionSummaryItem) => void;
  onSubmit: (region: AddEditRegion) => void;
  onCloseModal: () => void;
}

export default createContext<Context>({
  loading: false,
  sending: false,
  data: [],
  totalRecords: 0,
  searchTerm: '',
  setSearchTerm: () => {},
  isModalOpen: false,
  isEdit: false,
  editingRegion: { name: '' },
  onAction: () => {},
  onSubmit: () => {},
  onCloseModal: () => {},
});
